module.exports = __webpack_public_path__ + "static/img/logo.6d5cefd9.png";